import emojioneOptions from './emojioneOptions';

const entryEmojiOptions = {
  ...emojioneOptions,
  styles: {
    ...emojioneOptions.styles,
    height: '8.5pt',
    width: '8.5pt',
    margin: '0'
  }
};

export default entryEmojiOptions;



/** WEBPACK FOOTER **
 ** ./src/images/entryEmojiOptions.js
 **/